import React from 'react';
import { Link } from 'react-router-dom';

export const SerializedWorkSummary = ({ records = [], testId }) => {
  if (!records.length) return null;
  return <div className="space-y-1.5 text-xs min-w-0" data-testid={testId}>
    <p className="font-semibold">Serialized parts touched</p>
    {records.map((r) => <div key={r.component_id} className="border-l-2 border-emerald-300 pl-2 break-words"
      data-testid={`${testId}-${r.component_id}`}>
      <Link data-testid={`${testId}-link-${r.component_id}`} className="text-blue-700 underline"
        to={`/inventory/serialized/${r.component_id}`}>{r.mfr_part_number} · SN {r.serial_number}</Link>
      <p>{r.action === 'associated' ? `Work linked · ${r.from_location}` : `${r.from_location} → ${r.to_location} · ${r.status.replaceAll('_', ' ')}`}</p>
    </div>)}
  </div>;
};